export default __webpack_public_path__ + "static/media/pivotMinimise.b276e420.svg";